import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../Components/Header/Header";
import Icons from "../../../Constants/Icons";
import ReferralUserList from "../../../Components/ReferralUserList/ReferralUserList";
import CustomDropdown from "../../../Components/DropDown/CustomDropdown";
import CustomPagination from "../../../Components/CustomPagination/CustomPagination";
import {
    onApiCallPostGetReferral,
} from "../../../Core/Apicall";
import {
    setLoadingFalse,
    setLoadingTrue,
} from "../../../Config/Actions/loadingActions";
import EmptyData from "../../../Components/EmptyData/EmptyData";
import UseDebounce from "../../../Components/UseDebounce";

const REFERRAL_FILTERS = ["All Time", "Today", "This Week", "This Month", "Last 6 Months"];
const ITEMS_PER_PAGE = 15;

function ReferralManagement() {
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.isLoading);
    const [referralData, setReferralData] = useState({ data: [], totalCount: 0 });
    const [referralSearch, setReferralSearch] = useState("");
    const [referralPage, setReferralPage] = useState(0);
    const [referralFilter, setReferralFilter] = useState("All Time");
    const debouncedReferralSearch = UseDebounce(referralSearch, 500);
    const isInitialReferralRender = useRef(true);
    const searchInputRef = useRef(null);

    const fetchReferral = useCallback(
        async (page = 0, search = "", filter = "All Time") => {
            dispatch(setLoadingTrue());
            try {
                const res = await onApiCallPostGetReferral({
                    offset: page + 1,
                    limit: ITEMS_PER_PAGE,
                    searchQuery: search,
                    filter,
                });
                setReferralData(res);
                setReferralPage(page);
            } catch (e) {
                console.error(e);
            } finally {
                dispatch(setLoadingFalse());
            }
        },
        [dispatch]
    );

    useEffect(() => {
        isInitialReferralRender.current = true;
        fetchReferral(0, "", "All Time");
    }, [])



    useEffect(() => {
        if (isInitialReferralRender.current) { isInitialReferralRender.current = false; return; }
        fetchReferral(0, referralSearch, referralFilter);
    }, [debouncedReferralSearch]);


    useEffect(() => {
        if (referralSearch != ""&&searchInputRef.current && document.activeElement !== searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [referralData]);

    const renderTableBody = () => {
        return <ReferralUserList currentUsers={referralData?.data} />;
    };

    const listTitle =
        "Referral User List"

    const dataLength = referralData?.data?.length
    const totalCount = referralData?.totalCount

    return (
        <div>
            <Header name={"Referral User"} />
            <div className="astrologers-list-parent padding-top-bottom">
                <div className="frame-parent2">
                    <div
                        className="custom-box-user"
                        style={{ alignItems: "center", flexWrap: "wrap", gap: "12px" }}
                    >

                      


                        <div className="custom-box-search-div" >
                            <img className="custom-image" alt="" src={Icons.ic_search} />
                            <input
                                type="text"
                                disabled={isLoading}
                                ref={searchInputRef}
                                className="searchTextInput"
                                placeholder={"Search by name or email"}
                                value={referralSearch}
                                onChange={(e) =>
                                    setReferralSearch(e.target.value)
                                }
                            />
                        </div>

                          <div className="custom-container-dropdown-div" style={{ marginLeft: "auto" }}>
                            <CustomDropdown
                                dropDownLabel={referralFilter}
                                items={REFERRAL_FILTERS}
                                color="blue"
                                onSelect={(f) => {
                                    setReferralFilter(f);
                                    fetchReferral(0, referralSearch, f);
                                }}
                                customLabelStyle={{ fontWeight: "400", color: "white" }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="Event-custom-style">
                <div className="lastWeekEndDiv Event-AlignSelf-stretch">
                    <div className="user_title">{listTitle}</div>
                    <div className="transparentWhite">
                        <nav className="grid-cols grid_7 fontSize16WithoutFlex transparentWhite-padding">
                            <div className="user_name">Referrer</div>
                            <div className="user_name">Referred User</div>
                            <div className="user_name">Date</div>
                        </nav>
                        {renderTableBody()}
                    </div>
                </div>
            </div>

            {dataLength === 0 && (
                <div className="empty-centered">
                    <EmptyData />
                </div>
            )}

            {dataLength !== 0 && (
                <div className="Custom-Pagination">
                    <CustomPagination
                        pageCount={Math.ceil(totalCount / ITEMS_PER_PAGE)}
                        pageRangeDisplayed={3}
                        initialPage={referralPage}
                        marginPagesDisplayed={1}
                        onPageChange={({ selected }) => {
                            fetchReferral(selected, referralSearch, referralFilter);
                        }}
                    />
                </div>
            )}
        </div>
    );
}

export default ReferralManagement;